<script setup lang="ts">
import { ElIcon } from 'element-plus'
import { computed } from 'vue'

import ChevronIcon from '../../../assets/icons/chevron.svg?component'
import { getDateRangeLabel } from '../../../utils'
import BoxComponent from '../../atoms/BoxComponent.vue'
import FlexComponent from '../../atoms/FlexComponent.vue'
import TypographyComponent from '../../atoms/TypographyComponent.vue'
import DateRangePicker from '../../organisms/DateRangePicker.vue'

const dateRange = defineModel<{ startDate: string; endDate: string } | undefined>('dateRange')
defineProps<{ placement?: 'bottom' | 'bottom-start' | 'bottom-end' }>()

const label = computed(() => getDateRangeLabel(dateRange.value?.startDate, dateRange.value?.endDate, { emptyLabel: 'Date' }))
</script>
<template>
  <DateRangePicker v-model="dateRange" has-custom-button show-clear-button :placement="placement">
    <template #customButton>
      <FlexComponent :gap="4" align="center">
        <BoxComponent :title="label">
          <TypographyComponent variant="label-large" text-wrap="nowrap" text-truncate>
            {{ label }}
          </TypographyComponent>
        </BoxComponent>
        <ElIcon :size="18" class="chevron-icon">
          <ChevronIcon />
        </ElIcon>
      </FlexComponent>
    </template>
  </DateRangePicker>
</template>
